import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "fixed-buttons"
}

import { reactive, computed, ref, nextTick, watch } from "vue";
import { documentService } from "@/api/services/document";
import { useSettingsStore } from "@/api/store/settings";
import { useRouter } from "vue-router";
import TableView from "./TableView.vue";

import FormField from "@/components/SwandoolaDocBuilder/FormField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormViewer',
  setup(__props) {

const router = useRouter();

const settingsStore = useSettingsStore();

const state = reactive({
  document: null as any,
});

const autoSaving = ref(false);
let autoSaveTimer: ReturnType<typeof setTimeout> | null = null;

const documentId = computed(() => router.currentRoute.value.params.id);

const fetchDocument = async () => {
  documentService
    .show(documentId.value as string)
    .then((response) => {
      state.document = response;
    })
    .catch((error) => {
      console.log(error);
    });
};

fetchDocument();

const autoSave = async () => {
  if (!state.document || state.document.status === 'complete') return;
  autoSaving.value = true;
  try {
    await documentService.update(state.document.id, {
      data: state.document.data,
      completed: false,
    });
  } finally {
    autoSaving.value = false;
  }
};

watch(
  () => state.document?.data?.items,
  () => {
    if (!state.document || state.document.status === 'complete') return;
    if (autoSaveTimer) clearTimeout(autoSaveTimer);
    autoSaveTimer = setTimeout(autoSave, 1000);
  },
  { deep: true }
);

const checkRequiredFields = async (data: any): Promise<boolean> => {
  for (let index = 0; index < data.items.length; index++) {
    const item = data.items[index];

    if (
      item.isRequired &&
      (!item.value || item.value.toString().trim() === "")
    ) {
      await nextTick();

      const el = document.querySelector(`[data-index="${index}"]`) as HTMLElement;

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus?.();
      }

      alert(`Please fill in the required field: "${item.label}"`);
      return false;
    }
  }

  return true;
};

const processLinks = (content: any) => {
  if (!content || content.length === 0) {
    return content;
  }

  // Regular expression to find URLs in text
  const urlRegex = /\bhttps?:\/\/[^\s<>]+/g;

  return content.replace(
    urlRegex,
    (url) => `<a href="${url}" target="_blank">${url}</a>`
  );
};

const submit = async (completed: boolean) => {
  if (completed && !(await checkRequiredFields(state.document.data))) {
    return;
  }

  const response = await documentService.update(state.document.id, {
    data: state.document.data,
    completed: completed,
  });

  fetchDocument();
};

const getSectionItems = (sectionIndex: number) => {
  const items = state.document.data.items;
  const nextSectionIndex = items.findIndex(
    (item, index) => index > sectionIndex && item.type === "section"
  );

  const endIndex = nextSectionIndex === -1 ? items.length : nextSectionIndex;

  return items
    .slice(sectionIndex + 1, endIndex)
    .map((item: any, index: number) => ({
      ...item,
      originalIndex: sectionIndex + 1 + index,
    }));
};

const isItemInSection = (index: number) => {
  const items = state.document.data.items;
  const previousItems = items.slice(0, index);
  const lastSection = previousItems.findLast((item) => item.type === "section");
  return !!lastSection;
};

const toggleSection = (sectionItem: any) => {
  sectionItem.isExpanded = !sectionItem.isExpanded;
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.document)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "document-viewer"
      }, {
        default: _withCtx(() => [
          (state.document.status === 'complete')
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                "max-width": "600",
                class: "mx-auto mb-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_alert, {
                    type: "success",
                    elevation: "2",
                    class: "mx-2",
                    color: "success",
                    dark: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("p", { class: "text-h6 text-white" }, "Form Submitted", -1),
                              _createElementVNode("p", { class: "text-body-1 text-white" }, " You have already submitted this form, you cannot edit it. ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_sheet, { class: "mx-auto px-3 pb-12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                "validate-on": "submit lazy",
                disabled: state.document.status === 'complete',
                class: "pb-12"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.document.data.items, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.type === 'section')
                        ? (_openBlock(), _createBlock(FormField, {
                            key: 0,
                            item: item,
                            onToggleSection: toggleSection
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSectionItems(index), (subItem, subIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: subIndex }, [
                                  (
                    state.document.data.items[
                      subItem.originalIndex
                    ].content?.includes('<table')
                  )
                                    ? (_openBlock(), _createBlock(TableView, {
                                        key: 0,
                                        modelValue: 
                    state.document.data.items[subItem.originalIndex].content
                  ,
                                        "onUpdate:modelValue": ($event: any) => ((
                    state.document.data.items[subItem.originalIndex].content
                  ) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (
                    subItem.type === 'text' &&
                    !state.document.data.items[
                      subItem.originalIndex
                    ].content?.includes('<table')
                  )
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          innerHTML: processLinks(subItem.content),
                                          class: "text-wrap"
                                        }, null, 8, _hoisted_1))
                                      : (
                    !state.document.data.items[
                      subItem.originalIndex
                    ].content?.includes('<table')
                  )
                                        ? (_openBlock(), _createBlock(FormField, {
                                            key: 2,
                                            modelValue: 
                    state.document.data.items[subItem.originalIndex].value
                  ,
                                            "onUpdate:modelValue": ($event: any) => ((
                    state.document.data.items[subItem.originalIndex].value
                  ) = $event),
                                            item: subItem,
                                            "parent-section": item
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "item", "parent-section"]))
                                        : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["item"]))
                        : (!isItemInSection(index))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (item.content && item.content.includes('<table'))
                                ? (_openBlock(), _createBlock(TableView, {
                                    key: 0,
                                    modelValue: item.content,
                                    "onUpdate:modelValue": ($event: any) => ((item.content) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (
                item.type === 'text' && item.content && !item.content.includes('<table')
              )
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      innerHTML: processLinks(item.content),
                                      class: "text-wrap"
                                    }, null, 8, _hoisted_2))
                                  : (item.type !== 'text' || (item.type === 'text' && !item.content))
                                    ? (_openBlock(), _createBlock(FormField, {
                                        key: 2,
                                        modelValue: state.document.data.items[index].value,
                                        "onUpdate:modelValue": ($event: any) => ((state.document.data.items[index].value) = $event),
                                        item: item,
                                        "data-index": index
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "item", "data-index"]))
                                    : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (state.document.status !== 'complete')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_btn, {
                          loading: autoSaving.value,
                          color: _unref(settingsStore).settings.secondaryColor,
                          block: "",
                          class: "mt-2 text-white",
                          text: "Save",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (submit(false)))
                        }, null, 8, ["loading", "color"]),
                        _createVNode(_component_v_btn, {
                          loading: 
              _unref(settingsStore).loading && state.document.status === 'complete'
            ,
                          color: _unref(settingsStore).settings.primaryColor,
                          block: "",
                          class: "mt-2 text-white",
                          text: "Save & Submit",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (submit(true)))
                        }, null, 8, ["loading", "color"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})